<template>
  <div id="app" class="app-container">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "app",
  methods: {
    menu() {
      window.scrollTo(0, 0);
    },
  },
  updated() {
    this.menu();
  },
};
</script>

<style lang="scss">
@import "./assets/css/public.scss";
@import "./assets/css/main.scss";
html,
body,
#app {
  height: 100%;
  font-family: PingFangSC-Medium, Microsoft YaHei, "\5FAE\8F6F\96C5\9ED1", Arial,
    sans-serif;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100vh;
  background: #f5f7fd;
  min-width: 1300px;
}
.app-container {
  color: $font-color;
}
.el-avatar,
.el-drawer {
  overflow: inherit;
}
ul.el-popper {
  max-height: 200px;
  overflow: auto;
}
.module_breadcrumbs_active {
  color: var(--color-main);
  font-weight: 500;
}
/deep/ .el-date-editor .el-range__icon {
  line-height: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue